"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("events");
var actions_1 = __importDefault(require("./actions"));
var decode_1 = __importDefault(require("./decode"));
var encode_1 = __importDefault(require("./encode"));
var fetch_1 = __importDefault(require("./fetch"));
var queue_1 = __importDefault(require("./queue"));
var transparent48_1 = __importDefault(require("./transparent48"));
var transparent48v2_1 = __importDefault(require("./transparent48v2"));
var utils_1 = require("./utils");
var webSocket_1 = __importDefault(require("./webSocket"));
var Virtual = /** @class */ (function (_super) {
    __extends(Virtual, _super);
    function Virtual(_a) {
        var token = _a.token, // 用户token
        devTid = _a.devTid, // 设备devTid
        subDevTid = _a.subDevTid, // 子设备devTid
        _b = _a.debug, // 子设备devTid
        debug = _b === void 0 ? true : _b, // 是否为网页debug模式，否则为预览模式
        _c = _a.heartbeat, // 是否为网页debug模式，否则为预览模式
        heartbeat = _c === void 0 ? 7000 : _c, // 心跳间隔
        _d = _a.reconnect, // 心跳间隔
        reconnect = _d === void 0 ? false : _d, // ws断开自动重连
        _e = _a.delay, // ws断开自动重连
        delay = _e === void 0 ? 0 : _e, // 上报帧延时时间
        _f = _a.URL, // 上报帧延时时间
        URL = _f === void 0 ? {} : _f, // API地址
        _g = _a.report // 状态改变后是否上报包含参数的上报帧（非关联上报帧）
        , // API地址
        report = _g === void 0 ? false : _g // 状态改变后是否上报包含参数的上报帧（非关联上报帧）
        ;
        var _this = _super.call(this) || this;
        _this.URL = {
            console: 'https://console-openapi.aihomi.com',
            user: 'https://user-openapi.aihomi.com',
            ws: 'wss://hub.aihomi.com:184',
            ws48: 'wss://hub.aihomi.com:188',
            ws48v2: 'wss://hub.aihomi.com:194'
        };
        _this.task = [];
        _this.snapshot = {};
        // ws的命令队列
        _this['[[QUEUE]]'] = new queue_1.default();
        _this['[[ID]]'] = 0;
        _this.options = {
            debug: debug,
            delay: delay,
            devTid: devTid,
            heartbeat: heartbeat,
            reconnect: reconnect,
            report: report,
            subDevTid: subDevTid,
            token: token
        };
        _this.URL = __assign({}, _this.URL, URL);
        _this.init().catch(function (err) { return _this['[[REJECT]]'](err); });
        return _this;
    }
    Object.defineProperty(Virtual.prototype, "msgId", {
        get: function () {
            if (this['[[ID]]'] > 65535) {
                this['[[ID]]'] = 0;
            }
            return this['[[ID]]']++;
        },
        set: function (val) {
            this['[[ID]]'] = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Virtual.prototype, "readyState", {
        /**
         * WebSocket连接状态
         * 0 CONNECTING 1 OPEN
         * 2 CLOSING 3 CLOSED
         */
        get: function () {
            if (!this.webSocket) {
                return 0;
            }
            return this.webSocket.readyState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Virtual.prototype, "state", {
        get: function () {
            var snapshot = this.snapshot || {};
            var fields = (this.protocol || {}).fields || {};
            // 计算出所有字段的默认值
            return Object.keys(fields).reduce(function (status, key) {
                var snapshotVal = snapshot[key];
                var field = fields[key];
                status[key] =
                    snapshotVal !== undefined
                        ? utils_1.getCorrectVal(snapshotVal, field) // 检测val是否在字段定义的范围内
                        : utils_1.getValFromProtocol(field); // 从字段中获取默认值
                return status;
            }, {});
        },
        enumerable: true,
        configurable: true
    });
    /**
     * 当虚拟设备成功启动时执行
     * @param callback
     */
    Virtual.prototype.ready = function (callback) {
        if (typeof callback === 'function') {
            this['[[READY]]'].then(function () { return callback(); });
        }
        return this['[[READY]]'];
    };
    /**
     * 发送数据到云端
     * @param action
     * @param data
     */
    Virtual.prototype.send = function (action, data) {
        if (this.webSocket.readyState === 1) {
            if (this.transparent48) {
                this.transparent48.send(action, (data || {}).data);
            }
            else if (this.transparent48v2) {
                this.transparent48v2.send(action, (data || {}).data);
            }
            else {
                var frame = this.actions.send(action, data);
                if (frame) {
                    this.emit('send', frame);
                    this.webSocket.send(JSON.stringify(frame));
                }
            }
        }
    };
    /**
     * 接收云端数据
     * @param frame
     */
    Virtual.prototype.receive = function (data) {
        if (this.transparent48) {
            this.transparent48.receive(data);
        }
        else if (this.transparent48v2) {
            this.transparent48v2.receive(data);
        }
        else {
            try {
                var frame = JSON.parse(data);
                this.emit('receive', frame);
                this.actions.receive(frame);
            }
            catch (e) { }
        }
    };
    /**
     * 更新state
     * 和React中setState用法一样
     * @param {Object} state
     */
    Virtual.prototype.setState = function (state) {
        var _this = this;
        var fields = this.protocol.fields;
        var oState = this.state;
        var isUpdate = false;
        Object.keys(state).forEach(function (key) {
            if (fields[key]) {
                var field = fields[key];
                // 检查state是否改变
                if (oState[key] !== state[key]) {
                    isUpdate = true;
                }
                if (_this.options.report) {
                    field.UP.forEach(function (cmdId) { return _this['[[QUEUE]]'].add(cmdId); });
                }
                _this.snapshot[key] = state[key];
            }
        });
        if (isUpdate) {
            this.emit('update', this.state, oState);
        }
    };
    /**
     * 连接WebSocket
     */
    Virtual.prototype.connect = function () {
        // 如果webSocket是连着的就不建立新的连接
        if (this.readyState !== 1) {
            this.webSocket = webSocket_1.default(this);
        }
    };
    /**
     * 关闭WebSocket
     * 使设备离线
     */
    Virtual.prototype.close = function () {
        this.options.reconnect = false;
        if (this.webSocket) {
            this.webSocket.close();
        }
    };
    /**
     * 初始化
     */
    Virtual.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.initReady();
                        this.initFetch();
                        return [4 /*yield*/, this.initDevice()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.initSubDevice()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.initTransparent48()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.initTransparent48v2()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.initProtocol()];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.initSnapshot()];
                    case 6:
                        _a.sent();
                        this.initActions();
                        this.initDecode();
                        this.initEncode();
                        this.connect();
                        return [2 /*return*/];
                }
            });
        });
    };
    Virtual.prototype.initReady = function () {
        var _this = this;
        this['[[READY]]'] = new Promise(function (resolve, reject) {
            _this['[[REJECT]]'] = reject;
            _this['[[RESOLVE]]'] = resolve;
        });
    };
    Virtual.prototype.initFetch = function () {
        this.fetch = fetch_1.default(this);
    };
    Virtual.prototype.initDevice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var device, token, prodKey, devPriKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch.device.get(this.options.devTid)];
                    case 1:
                        device = _a.sent();
                        return [4 /*yield*/, this.fetch.device.token(device.productPublicKey)];
                    case 2:
                        token = _a.sent();
                        return [4 /*yield*/, this.fetch.device.prodKey(device.productPublicKey)];
                    case 3:
                        prodKey = _a.sent();
                        return [4 /*yield*/, this.fetch.devPriKey.get(device.productPublicKey)];
                    case 4:
                        devPriKey = _a.sent();
                        this.device = {
                            bindKey: device.bindKey,
                            devPriKey: devPriKey,
                            devTid: this.options.devTid,
                            devType: device.devType,
                            mid: device.mid,
                            model: device.model,
                            name: device.name,
                            prodKey: prodKey,
                            productPublicKey: device.productPublicKey,
                            subDevices: device.subDevices || [],
                            token: token,
                            workModeType: device.workModeType
                        };
                        return [2 /*return*/];
                }
            });
        });
    };
    Virtual.prototype.initTransparent48 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var devPriKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.device.workModeType === 'TRANSPARENT48')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetch.devPriKey.get(this.device.productPublicKey)];
                    case 1:
                        devPriKey = _a.sent();
                        this.device.devPriKey = devPriKey;
                        this.transparent48 = new transparent48_1.default(this);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Virtual.prototype.initTransparent48v2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var devPriKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.device.workModeType === 'TRANSPARENT48_V2')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetch.devPriKey.get(this.device.productPublicKey)];
                    case 1:
                        devPriKey = _a.sent();
                        this.device.devPriKey = devPriKey;
                        this.transparent48v2 = new transparent48v2_1.default(this);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Virtual.prototype.initSubDevice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var subDevice, model;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        /**
                         * 获取产品信息
                         * 如果时网关设备就拉取网关的信息
                         * 如果是独立设备就拉取独立设备的信息
                         */
                        this.subDevice = {
                            devTid: this.options.subDevTid || '',
                            devType: '',
                            mid: '',
                            model: '',
                            name: '',
                            productPublicKey: '',
                            subWorkMode: ''
                        };
                        if (!(this.options.subDevTid && this.device.devType === 'GATEWAY')) return [3 /*break*/, 2];
                        subDevice = utils_1.find(this.device.subDevices, function (_a) {
                            var devTid = _a.devTid;
                            return devTid === _this.options.subDevTid;
                        });
                        if (!subDevice) {
                            throw new Error("\u8BBE\u5907[" + this.options.devTid + "]\u6CA1\u6709\u5BF9\u5E94\u7684\u5B50\u8BBE\u5907[" + this.options.subDevTid + "]");
                        }
                        this.subDevice.devType = subDevice.devType;
                        this.subDevice.mid = subDevice.mid;
                        this.subDevice.name = subDevice.name;
                        this.subDevice.productPublicKey = subDevice.productPublicKey;
                        return [4 /*yield*/, this.fetch.device.model(this.subDevice.productPublicKey)];
                    case 1:
                        model = _a.sent();
                        this.subDevice.model = model.model;
                        this.subDevice.subWorkMode = model.subWorkMode;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Virtual.prototype.initProtocol = function () {
        return __awaiter(this, void 0, void 0, function () {
            var productPublicKey, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        productPublicKey = this.options.subDevTid ? this.subDevice.productPublicKey : this.device.productPublicKey;
                        _a = this;
                        return [4 /*yield*/, this.fetch.protocol.get(productPublicKey)];
                    case 1:
                        _a.protocol = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Virtual.prototype.initSnapshot = function () {
        return __awaiter(this, void 0, void 0, function () {
            var snapshot, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.fetch.snapshot.get(this.options.devTid, this.options.subDevTid)];
                    case 1:
                        snapshot = _a.sent();
                        this.snapshot = __assign({}, this.snapshot, snapshot);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.warn(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Virtual.prototype.initActions = function () {
        this.actions = actions_1.default(this);
    };
    Virtual.prototype.initDecode = function () {
        this.decode = decode_1.default(this);
    };
    Virtual.prototype.initEncode = function () {
        this.encode = encode_1.default(this);
    };
    Virtual.version = process.env.VERSION;
    return Virtual;
}(events_1.EventEmitter));
exports.default = Virtual;



// WEBPACK FOOTER //
// ./src/index.ts